import {observer} from "mobx-react-lite"
import React from "react"
import valueOutput from "../store/entities/ValueOutput"
import Select from "react-select"
import {selectStyler} from "./SelectStyler";

export interface UnitOption {
    label: string,
    value: string,
}

export const UnitSelection = observer(({destination}: { destination: valueOutput }) => {

    return <Select<UnitOption>
        placeholder={"ед. изм."}
        {...selectStyler}
        defaultValue={destination.unitsDefaultOption}
        onChange={(value) => {
            if (value) {
                destination.saveUnit(value.value)
            }
        }
        }
        options={destination.unitsOptions}
    />
})

